import React, { useState, useEffect, useRef, Fragment } from "react";
import { useSelector } from "react-redux";
import { SuperContentSelector } from "../../../redux/reducers";
import ButtonSwitcher from "../../../components/ButtonSwitcher";
import Firebase from "../../../firebasehelper";
import { tabs } from "../constants/selections";
import FeedContent from "./FeedContent";
import FeedTags from "./FeedTags";
import FeedPosting from "./FeedPosting";
import "./index.css";

const AddPost = ({ selectedDate, onAdd, brand_name, hex, white }) => {
  const [isPostable, setIsPostable] = useState(false);
  const [tab, setTab] = useState(tabs[0]);
  const [hot_topic_tags, setHotTopicTags] = useState([]);
  const [events, setEvents] = useState([]);
  const [products, setProducts] = useState([]);
  const [articles, setArticles] = useState([]);
  const [feed, setFeed] = useState({});
  const dismissElement = useRef();
  const brand = useSelector((state) => state.brand);
  const superContents = useSelector(SuperContentSelector);
  useEffect(() => {
    if (brand_name) {
      // add post for brand
      Firebase.getAllHotTopics(brand_name, (hot_topics) => {
        let hot_topic_tags = hot_topics.map((topic) => {
          let label = `${topic.starting_monday
            .toDate()
            .toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            })} - ${topic.tag || topic.title}`;
          let value = topic;
          return { label, value };
        });
        setHotTopicTags(hot_topic_tags);
      });
      Firebase.getAllEvents(brand_name, (events) => setEvents(events));
      Firebase.getArticlesByBrand(brand_name, (articles) =>
        setArticles(articles)
      );
    } else {
      //add post for super content
      console.log("superContents", superContents);
    }
    if (brand && brand.packages) {
      const packages = brand.packages;
      let bPckgs_ids = Object.keys(brand.packages);
      const pkgs = bPckgs_ids.map((id) => ({ ...packages[id], id }));
      setProducts([...pkgs.filter((item) => item.active)]);
    }
  }, [brand_name]);
  useEffect(() => {
    if (
      feed.media_type &&
      feed.media_url &&
      feed.title &&
      feed.content &&
      feed.type &&
      feed.topic
    )
      setIsPostable(true);
    else setIsPostable(false);
  }, [feed]);
  const handleChangeTab = (tab) => {
    setTab(tab);
  };
  const handleClickClose = () => {
    dismissElement.current.click();
  };
  const handleClickCreate = () => {
    onAdd(feed);
  };
  const handleChangeContent = (content) => {
    setFeed({ ...feed, ...content });
  };
  const handleChangeTags = (tags) => {
    setFeed({ ...feed, ...tags });
  };
  const handleChangeTime = (scheduling) => {
    setFeed({ ...feed, ...scheduling });
  };

  return (
    <div
      className="modal fade add-post-dialog"
      id="add_feed_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content add-post-dialog-content">
          <div className="modal-header">
            <h5 className="modal-title">Add your post</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <ButtonSwitcher
              buttonsGroup={tabs}
              currentTab={tab}
              onSwitch={handleChangeTab}
              hex={hex}
              white={white}
            />
            <FeedContent
              onChangeContent={handleChangeContent}
              brand_name={brand_name}
              isVisible={tab === "Feed Content" ? true : false}
            />
            <FeedTags
              onChangeTags={handleChangeTags}
              hot_topic_tags={hot_topic_tags}
              articles={articles}
              events={events}
              products={products}
              isVisible={tab === "Feed Tags" ? true : false}
            />
            <FeedPosting
              selectedDate={selectedDate}
              onChangeTime={handleChangeTime}
              isVisible={tab === "Feed Posting" ? true : false}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              {tab === "Feed Content" && (
                <button
                  type="button"
                  className="btn btn-white btn-brand-hex"
                  style={{
                    "--hover-text-color": "black",
                    "--hover-color": "white",
                    backgroundColor: hex || "white",
                    color: white ? "white" : "black",
                  }}
                  onClick={() => setTab("Feed Tags")}
                >
                  Next
                </button>
              )}
              {tab === "Feed Tags" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Feed Content")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-white btn-brand-hex"
                    style={{
                      "--hover-text-color": "black",
                      "--hover-color": "white",
                      backgroundColor: hex || "white",
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Feed Posting")}
                  >
                    Next
                  </button>
                </Fragment>
              )}
              {tab === "Feed Posting" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Feed Tags")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={!isPostable}
                    onClick={handleClickCreate}
                  >
                    Create
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPost;



// WEBPACK FOOTER //
// ./src/screens/Feeds/components/AddPost.js